import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import {
  firebaseConfig_DEV,
  firebaseConfig_PROD,
} from "./config/firebaseConfig";

// True for local dev server (`npm start`) and for builds made with
// `npm run build:dev` (FELLA_TARGET=dev), which is what deploys to the
// rhccc-development Firebase project via `firebase use dev`. A plain
// `npm run build` always sets NODE_ENV to "production", so FELLA_TARGET is
// what actually distinguishes a dev deploy from a prod deploy.
const IS_DEV =
  process.env.NODE_ENV === "development" || process.env.FELLA_TARGET === "dev";
const firebaseConfig = IS_DEV ? firebaseConfig_DEV : firebaseConfig_PROD;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { app, auth, db, storage, analytics, IS_DEV };
